import React from "react";

const Kotlin_Booleans = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Booleans</h1>
      <p>Content for Kotlin Booleans goes here.</p>
    </div>
  );
};

export default Kotlin_Booleans;
